import type {Icon} from '@primer/octicons-react'
import ReasonLabel from './ReasonLabel'
import type {CommitSignatureType} from '../signed-commit-types'

import styles from './SignedCommitHeader.module.css'

export default function SignedCommitHeader({
  icon: IconComponent,
  iconColor,
  id,
  reason,
  isViewer,
  hasSignature,
  verificationStatus,
  signatureType,
  signedByGitHub,
  keyExpired,
  keyRevoked,
}: {
  icon: Icon
  iconColor: string
  id?: string
  reason: string
  isViewer: boolean
  hasSignature: boolean
  verificationStatus: string
  signatureType: CommitSignatureType
  signedByGitHub: boolean
  keyExpired: boolean
  keyRevoked: boolean
}) {
  return (
    <div id={id} data-testid="signed-commit-header" className="d-flex p-2">
      <div className="pr-2">
        <span style={{color: iconColor}}>
          <IconComponent />
        </span>
      </div>
      <div className={styles.messageContent}>
        <ReasonLabel
          reason={reason}
          isViewer={isViewer}
          hasSignature={hasSignature}
          verificationStatus={verificationStatus}
          signatureType={signatureType}
          signedByGitHub={signedByGitHub}
          keyExpired={keyExpired}
          keyRevoked={keyRevoked}
        />
      </div>
    </div>
  )
}
